import React, { useRef, useEffect, useState, useContext } from "react";
import {
  Paper,
  Tooltip,
  InputAdornment,
  Typography,
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  InputLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AntTabs, AntTab } from "../Separaciones/tabs_style";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import * as XLSX from "xlsx"; // Importa la librería xlsx
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { ContextSession } from "../../services/ContextSession";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import excelBoton from "./excelBoton.jpg";
import formatoExcel from "./FormatoReversiones.xlsx";
import formatoExcel2 from "./FormatoReversionPatronalMaestro.xlsx";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download"; // Opcional: ícono bonito para el botón Descargar

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none",
    borderLeft: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#C1C1C1",
  },
}));

export default function ReversionPatronal() {
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate();
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [hojasExcel, setHojasExcel] = useState([]);
  const [observacion, setObservacion] = useState("");
  const [planillaTipo, setPlanillaTipo] = useState("");
  const [hojaSeleccionada, setHojaSeleccionada] = useState("");
  const [tipoMovimiento, setTipoMovimiento] = useState("");
  const [fechaInicial, setFechaInicial] = useState("");
  const [fechaFinal, setFechaFinal] = useState("");
  const [tablaDatos, setTablaDatos] = useState([]); // Para guardar los datos de la hoja seleccionada
  const [encabezados, setEncabezados] = useState([]); // Para guardar los encabezados de la tabla
  const [hojaVacia, setHojaVacia] = useState(false); // Para controlar si la hoja seleccionada está vacía
  let sessi = useContext(ContextSession);
  // Estados para el diálogo y el envío
  const [openDialog, setOpenDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]); // Nuevo estado para los datos de la API
  const [loteId, setLoteId] = useState(""); // Nuevo estado para guardar el ID del lote
  const fileInputRef = useRef(null);

  //Descargar formatos excel
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
  const [formatoSeleccionado, setFormatoSeleccionado] = useState("Individual");

  const formatDate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  useEffect(() => {
    // Actualizar el ancho del contenedor al montar y al cambiar el tamaño de la ventana
    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => {
      window.removeEventListener("resize", updateContainerWidth);
    };
  }, []);

  const updateContainerWidth = () => {
    if (containerRef.current) {
      const width = containerRef.current.clientWidth;
      setContainerWidth(width);
    }
  };

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleMesChange = (e) => {
    // e.target.value viene como "YYYY-MM"

    const [yStr, mStr] = e.target.value.split("-");
    const y = Number(yStr);
    const m = Number(mStr); // 1..12
    const first = new Date(y, m - 1, 1);
    const last = new Date(y, m, 0);
    setFechaInicial(formatDate(first)); // YYYY-MM-01
    setFechaFinal(formatDate(last)); // YYYY-MM-<último>
  };

  // Esta función maneja la selección del archivo Excel
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      // Leer el archivo Excel
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const wb = XLSX.read(binaryStr, { type: "binary" });
        // Obtener los nombres de las hojas
        const sheetNames = wb.SheetNames;
        setHojasExcel(sheetNames); // Guardamos los nombres de las hojas en el estado
      };
      reader.readAsBinaryString(file); // Leemos el archivo como binario
    }
  };

  // Esta función maneja la selección de la hoja
  const handleHojaChange = (event) => {
    const hojaSeleccionada = event.target.value;
    setHojaSeleccionada(hojaSeleccionada);
    if (hojaSeleccionada && selectedFile) {
      leerDatosDeHoja(hojaSeleccionada);
    }
  };

  // Esta función lee los datos de la hoja seleccionada y los muestra en la tabla
  const leerDatosDeHoja = (hojaSeleccionada) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const wb = XLSX.read(binaryStr, { type: "binary" });
      const hoja = wb.Sheets[hojaSeleccionada];
      const datos = XLSX.utils.sheet_to_json(hoja, { header: 1 });

      if (datos.length <= 1) {
        setHojaVacia(true);
        setEncabezados([]);
        setTablaDatos([]);
      } else {
        const encabezados = datos[0];
        const nombreHoja = hojaSeleccionada.toLowerCase();

        const indiceCotizante = encabezados.findIndex((header) =>
          header.toString().toLowerCase().includes("cotizante")
        );

        const esHojaValida = ["detallado", "maestro"].includes(nombreHoja);

        const filasTransformadas = datos.slice(1).map((row) => {
          if (esHojaValida && indiceCotizante !== -1) {
            const valor = row[indiceCotizante];
            if (typeof valor === "number" || typeof valor === "string") {
              const strVal = valor.toString();
              if (strVal.length === 7) {
                row[indiceCotizante] = "0" + strVal;
              }
            }
          }
          return row;
        });

        setEncabezados(encabezados);
        setTablaDatos(filasTransformadas);
        setHojaVacia(false);
      }
    };
    reader.readAsBinaryString(selectedFile);
  };

  const handleTipoMovimientoChange = (event) => {
    setTipoMovimiento(event.target.value);
    if (event.target.value === "Movimiento") {
      // Mostrar los datepickers cuando se selecciona "Movimiento"
      setFechaInicial("");
      setFechaFinal("");
    }
  };

  const limpiarDatos = () => {
    setSelectedFile(null);
    setHojasExcel([]);
    setHojaSeleccionada("");
    setTipoMovimiento("");
    setPlanillaTipo("");
    setObservacion("");
    setTablaDatos([]);
    setEncabezados([]);
    setFechaInicial("");
    setFechaFinal("");
    setHojaVacia(false);

    // Resetear el input de archivo
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Agrega lógica para deshabilitar el radio "Movimiento"
  const isMovimientoDisabled = planillaTipo === "Patronal";

  const [errorFecha, setErrorFecha] = useState(""); // Estado para manejar el error de fechas

  // Validar que fechaInicial no sea mayor que fechaFinal
  useEffect(() => {
    if (
      fechaInicial &&
      fechaFinal &&
      new Date(fechaInicial) > new Date(fechaFinal)
    ) {
      setErrorFecha("La fecha inicial no puede ser mayor que la fecha final.");
    } else {
      setErrorFecha(""); // Limpiar el error si las fechas son válidas
    }
  }, [fechaInicial, fechaFinal]);

  // Determina si el botón "Subir Archivo" debe estar habilitado
  const isSubirArchivoDisabled = !(
    (
      selectedFile && // Archivo seleccionado
      planillaTipo && // Tipo de planilla seleccionado
      hojaSeleccionada && // Hoja de Excel seleccionada
      tipoMovimiento && // Radio seleccionado
      (tipoMovimiento === "Maestro" ||
        (tipoMovimiento === "Movimiento" && fechaInicial && fechaFinal)) && // Validación de movimiento con fechas
      !errorFecha
    ) // No hay error en las fechas
  );

  const handleSubirArchivo = () => {
    setOpenDialog(true); // Abrir el diálogo de confirmación
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Cerrar el diálogo de confirmación
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false); // Cerrar el diálogo de éxito
  };

  const handleEnviarDatos = async () => {
    setLoading(true); // Mostrar el indicador de carga
    try {
      const formData = new FormData();
      formData.append("archivo", selectedFile);
      formData.append("tipoPlanilla", planillaTipo);
      formData.append("Observacion", observacion);
      formData.append("hojaExcel", hojaSeleccionada);
      formData.append("tipoReversion", tipoMovimiento);

      // Verificar tipoMovimiento antes de añadir las fechas
      if (tipoMovimiento === "Movimiento") {
        formData.append("fechaInicial", fechaInicial);
        formData.append("fechaFinal", fechaFinal);
      } else {
        formData.append("fechaInicial", ""); // Campos vacíos
        formData.append("fechaFinal", "");
      }

      const response = await fetch(
        "https://bei360.injupemp.gob.hn:8444/api/SGOPER/SubirReversion/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
          body: formData,
        }
      );

      const responseData = await response.json(); // Siempre leer la respuesta

      if (response.ok) {
        console.log("Respuesta de la API:", responseData);

        // Extraer el IdDocumento de la respuesta
        const loteId = responseData.IdDocumento;
        setLoteId(loteId); // Guardar el ID del lote

        // Obtener datos de la API correspondiente usando el IdDocumento
        await fetchApiData(loteId);

        setOpenSuccessDialog(true); // Abrir el diálogo de éxito
        limpiarDatos(); // Limpiar los datos después de subir el archivo
      } else {
        console.error("Error al subir el archivo:", responseData);
        // Mostrar el mensaje de error de la API
        alert(
          "No se pudo procesar el archivo Excel seleccionado.\n\n" +
            "Detalle técnico: " +
            (responseData.error || "Error desconocido.") +
            "\n\n" +
            "Posibles causas:\n" +
            "- El archivo está dañado, incompleto o tiene formato incompatible.\n" +
            "- El archivo fue generado por un programa diferente a Microsoft Excel.\n" +
            "- Existen hojas o rangos con nombres inválidos, duplicados o vacíos.\n\n" +
            "Soluciones recomendadas:\n" +
            "1. Abra el archivo en Microsoft Excel y guárdelo nuevamente como archivo .xlsx.\n" +
            "2. Verifique que todas las hojas tengan nombre y no existan rangos definidos inválidos.\n" +
            "3. Si el archivo tiene tablas dinámicas, conexiones externas o fórmulas complejas, elimínelas y guarde una copia simplificada.\n\n" +
            "Si el problema persiste, contacte al soporte técnico."
        );
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      alert(`Error al realizar la solicitud: ${error.message}`);
    } finally {
      setLoading(false); // Detener el indicador de carga
      setOpenDialog(false); // Cerrar el diálogo de confirmación
    }
  };
  const fetchApiData = async (loteId) => {
    try {
      let apiUrl = "";
      if (tipoMovimiento === "Maestro") {
        apiUrl = `https://bei360.injupemp.gob.hn:8444/api/SGOPER/ReversionesMaestroLote/?estado=0&Lote=${loteId}`;
      } else {
        apiUrl = `https://bei360.injupemp.gob.hn:8444/api/SGOPER/ReversionesMovimientosLote/?estado=0&Lote=${loteId}`;
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessi.sessionData.token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setApiData(data);
      } else {
        console.error("Error al obtener datos de la API:", response.statusText);
      }
    } catch (error) {
      console.error("Error al obtener datos de la API:", error);
    }
  };

  // Campos para la tabla según el tipo de movimiento
  const getTableFields = () => {
    if (tipoMovimiento === "Maestro") {
      return [
        { key: "cdrp", label: "Cotizante" },
        { key: "nombre_participante", label: "Nombre" },
        { key: "ramo", label: "Ramo" },
        { key: "ajuste_individual", label: "Ajuste Individual" },
        { key: "intereses", label: "Intereses" },
        { key: "ajuste_aporte_patronal", label: "Ajuste Aporte Patronal" },
        { key: "id_documento_reversion", label: "Lote" },
        { key: "observacion_actualizado", label: "Observación de Ejecución" },
        { key: "observacion_documento", label: "Observación" },
        { key: "usuario_registro", label: "Usuario Registro" },
      ];
    } else {
      return [
        { key: "cdrp", label: "Cotizante" },
        { key: "nombre_participante", label: "Nombre" },
        { key: "ramo", label: "Ramo" },
        { key: "ajuste_individual", label: "Ajuste Individual" },
        { key: "intereses", label: "Intereses" },
        { key: "sueldos", label: "Sueldos" },
        { key: "ajuste_aporte_patronal", label: "Ajuste Aporte Patronal" },
        { key: "fecha_inicial", label: "Fecha Inicial" },
        { key: "fecha_final", label: "Fecha Final" },
        { key: "id_documento_reversion", label: "Lote" },
        { key: "observacion_actualizado", label: "Observación de Ejecución" },
        { key: "observacion_documento", label: "Observación" },
        { key: "usuario_registro", label: "Usuario Registro" },
      ];
    }
  };

  // Función para manejar el cambio en el tipo de planilla
  const handlePlanillaTipoChange = (event) => {
    const selectedPlanillaTipo = event.target.value;
    setPlanillaTipo(selectedPlanillaTipo);

    // Si el tipo de planilla es "Patronal", cambiar el tipo de movimiento a "Maestro"
    if (selectedPlanillaTipo === "Patronal") {
      setTipoMovimiento("Maestro");
    }
  };

  const descargarFormatoExcel = () => {
    // formatoExcel puede ser una URL relativa en el bundle (como /static/media/...), depende de tu config.
    // Creamos un enlace invisible y forzamos la descarga
    const link = document.createElement("a");
    link.href = formatoExcel;
    link.setAttribute("download", "FormatoReversiones.xlsx"); // Nombre del archivo a descargar
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const descargarFormatoExcel2 = () => {
    // formatoExcel puede ser una URL relativa en el bundle (como /static/media/...), depende de tu config.
    // Creamos un enlace invisible y forzamos la descarga
    const link = document.createElement("a");
    link.href = formatoExcel2;
    link.setAttribute("download", "FormatoReversionPatronalMaestro.xlsx"); // Nombre del archivo a descargar
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2
              style={{
                marginRight: "8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <UploadFileIcon
                style={{ color: "black", marginRight: "8px", fontSize: 30 }}
              />
              Cargar Reversión
              <UploadFileIcon
                style={{ color: "black", marginLeft: "8px", fontSize: 30 }}
              />
            </h2>
          </div>
        </Container>
      </Grid>

      <Grid container direction="column" alignItems="center">
        <Container>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>
              Descargue el formato de excel compatible para la carga de
              reversiones pulsando el botón ubicado en la esquina superior
              derecha
            </Typography>
          </div>
        </Container>
      </Grid>

      {/* Botón flotante en esquina superior derecha */}
      <Box
        sx={{
          position: "fixed",
          top: 10,
          right: 10,
          zIndex: 9999,
          marginTop: "90px",
        }}
      >
        <Tooltip title="Descargar Formato Excel" arrow placement="left">
          <Button
            variant="contained"
            onClick={() => setOpenDownloadDialog(true)} // <-- Cambia esto
            title="Descargar Formato Excel"
            sx={{
              minWidth: "auto",
              padding: "2px",
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgb(199, 199, 199)",
              },
            }}
          >
            <img
              src={excelBoton}
              alt="Exportar a Excel"
              style={{
                height: "90px",
                width: "90px",
                cursor: "pointer",
              }}
            />
          </Button>
        </Tooltip>
      </Box>

      <Box boxShadow={2} marginTop={3}>
        <Card variant="outlined">
          <CardContent>
            <Grid
              container
              spacing={2}
              marginTop={2}
              justifyContent="center" // Centra los items horizontalmente
              alignItems="center" // Centra los items verticalmente
            >
              {/* Botón Seleccionar Archivo */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <Button
                  variant="contained"
                  component="label"
                  fullWidth
                  endIcon={<FileUploadIcon />}
                >
                  Seleccionar Archivo
                  <input
                    type="file"
                    hidden
                    ref={fileInputRef}
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                  />
                </Button>
              </Grid>

              {/* Botón Subir Archivo */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <Button
                  variant="contained"
                  fullWidth
                  endIcon={<DriveFolderUploadIcon />}
                  disabled={isSubirArchivoDisabled}
                  onClick={handleSubirArchivo}
                >
                  Cargar Archivo
                </Button>
              </Grid>

              {/* Botón Limpiar Datos */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <Button
                  variant="contained"
                  fullWidth
                  endIcon={<CleaningServicesIcon />}
                  onClick={limpiarDatos}
                >
                  Limpiar Datos
                </Button>
              </Grid>

              {/* Observación */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <FormControl fullWidth>
                  <TextField
                    label="Observación"
                    variant="outlined"
                    multiline
                    value={observacion}
                    onChange={(e) => setObservacion(e.target.value)}
                  />
                </FormControl>
              </Grid>

              {/* Select Planilla Tipo */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <FormControl fullWidth>
                  <InputLabel id="planillaTipo-label">Planilla Tipo</InputLabel>
                  <Select
                    labelId="planillaTipo-label"
                    label="Planilla Tipo"
                    value={planillaTipo}
                    onChange={handlePlanillaTipoChange} // Usar la nueva función para manejar el cambio
                  >
                    <MenuItem value="Individual">Individual</MenuItem>
                    <MenuItem value="Patronal">Patronal</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Select Hoja de Excel */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <FormControl fullWidth>
                  <InputLabel id="hojaExcel-label">Hoja de Excel</InputLabel>
                  <Select
                    labelId="hojaExcel-label"
                    label="Hoja de Excel"
                    value={hojaSeleccionada}
                    onChange={handleHojaChange}
                    disabled={!selectedFile}
                  >
                    {hojasExcel.map((hoja, index) => (
                      <MenuItem key={index} value={hoja}>
                        {hoja}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Radiogroup con opciones Maestro y Movimiento */}
              <Grid item xs={12} sm={6} md={3} lg={3.38}>
                <FormControl component="fieldset">
                  <RadioGroup
                    value={tipoMovimiento}
                    onChange={handleTipoMovimientoChange}
                    row // Para que las opciones estén en fila
                  >
                    <FormControlLabel
                      value="Maestro"
                      control={<Radio />}
                      label="Maestro"
                    />
                    <FormControlLabel
                      value="Movimiento"
                      control={<Radio />}
                      label="Movimiento"
                      disabled={isMovimientoDisabled} // Deshabilitar "Movimiento" si Planilla Tipo es "Patronal"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {/* Fecha Inicial y Fecha Final si se selecciona Movimiento */}
              {tipoMovimiento === "Movimiento" && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <TextField
                      label="Mes"
                      type="month"
                      fullWidth
                      // mostrar el mes del estado actual (usa fechaInicial como fuente)

                      value={fechaInicial ? fechaInicial.slice(0, 7) : ""}
                      onChange={handleMesChange}
                      InputLabelProps={{ shrink: true }}
                      onKeyDown={(e) => e.preventDefault()}
                      error={!!errorFecha}
                      helperText={errorFecha}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} lg={3.38}>
                    <TextField
                      label="Fecha Inicial"
                      type="date"
                      fullWidth
                      value={fechaInicial}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true, // Bloquea completamente el campo (no se puede editar ni seleccionar)
                      }}
                      error={!!errorFecha}
                      helperText={errorFecha}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3.38}>
                    <TextField
                      label="Fecha Final"
                      type="date"
                      fullWidth
                      value={fechaFinal}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true, // Bloquea completamente el campo (no se puede editar ni seleccionar)
                      }}
                      error={!!errorFecha}
                      helperText={errorFecha}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>

      {/* Mostrar mensaje si la hoja está vacía */}
      {hojaVacia ? (
        <Typography variant="h6" color="error" align="center">
          La hoja seleccionada no contiene datos.
        </Typography>
      ) : (
        // Tabla solo si la hoja no está vacía
        <TableContainer component={Paper} style={{ marginTop: 20 }}>
          <Table>
            <TableHead>
              <StyledTableRow>
                {encabezados.map((header, index) => (
                  <StyledTableCell key={index}>{header}</StyledTableCell>
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {tablaDatos.map((row, rowIndex) => (
                <StyledTableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <StyledTableCell key={cellIndex}>{cell}</StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
              {(() => {
                const columnasASumar = [
                  "AJUSTE DE COTIZACION INDIVIDUAL",
                  "INTERESES",
                  "SUELDOS",
                  "AJUSTE DE APORTE PATRONAL",
                ];

                const indices = encabezados
                  .map((col, idx) => ({
                    nombre: col.toString().toUpperCase(),
                    index: idx,
                  }))
                  .filter((col) => columnasASumar.includes(col.nombre));

                const totales = new Array(encabezados.length).fill(null);

                indices.forEach(({ nombre, index }) => {
                  const suma = tablaDatos.reduce((acc, fila) => {
                    const valor = parseFloat(fila[index]);
                    return acc + (isNaN(valor) ? 0 : valor);
                  }, 0);
                  totales[index] = `TOTAL ${nombre}: ${suma.toFixed(2)}`;
                });

                return (
                  <StyledTableRow>
                    {totales.map((valor, idx) => (
                      <StyledTableCell
                        key={`total-${idx}`}
                        colSpan={1}
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f0f0",
                        }}
                      >
                        {valor || ""}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                );
              })()}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Dialog de Confirmación */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>¿Está seguro de cargar el archivo?</DialogTitle>
        <DialogContent>
          <Typography>
            <b>Archivo:</b> {selectedFile?.name || "N/A"}
          </Typography>
          <Typography>
            <b>Observación:</b> {observacion || "N/A"}
          </Typography>
          <Typography>
            <b>Planilla Tipo:</b> {planillaTipo || "N/A"}
          </Typography>
          <Typography>
            <b>Tipo Reversión:</b> {tipoMovimiento || "N/A"}
          </Typography>
          <Typography>
            <b>Hoja de Excel:</b> {hojaSeleccionada || "N/A"}
          </Typography>
          {tipoMovimiento === "Movimiento" && (
            <>
              <Typography>
                <b>Fecha Inicial:</b> {fechaInicial || "N/A"}
              </Typography>
              <Typography>
                <b>Fecha Final:</b> {fechaFinal || "N/A"}
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="error" disabled={loading}>
            No
          </Button>
          <Button
            onClick={handleEnviarDatos}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Sí"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Éxito */}
      <Dialog open={openSuccessDialog} onClose={handleCloseSuccessDialog}>
        <DialogTitle textAlign={"center"}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <CheckCircleIcon color="success" />
            Archivo Cargado con Éxito
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography>
            El archivo se ha cargado correctamente a la plataforma.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={handleCloseSuccessDialog}
            color="primary"
            variant="contained"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseSuccessDialog}
        maxWidth={false}
        fullWidth
        scroll="paper"
        PaperProps={{
          sx: {
            width: "90vw", // o cualquier otro valor como '1000px'
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle textAlign={"center"}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <CheckCircleIcon color="success" fontSize="large" />
            <Typography variant="h5" component="div">
              Archivo Cargado con Éxito
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box mb={3}>
            <Typography variant="h6" gutterBottom>
              Número de Lote Cargado: <strong>{loteId}</strong>
            </Typography>
            <Typography variant="body1" paragraph>
              {apiData.length}{" "}
              {apiData.length === 1
                ? "registro procesado"
                : "registros procesados"}{" "}
              correctamente.
            </Typography>
          </Box>

          <TableContainer
            component={Paper}
            style={{ marginTop: 20, maxHeight: "60vh" }}
          >
            <Table stickyHeader aria-label="tabla de reversiones">
              <TableHead>
                <TableRow>
                  {getTableFields().map((field) => (
                    <StyledTableCell
                      key={field.key}
                      align={field.numeric ? "right" : "left"}
                    >
                      <b>{field.label}</b>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {apiData.length > 0 ? (
                  apiData.map((row, index) => (
                    <StyledTableRow key={index} hover>
                      {getTableFields().map((field) => (
                        <StyledTableCell
                          key={`${index}-${field.key}`}
                          align={field.numeric ? "right" : "left"}
                        >
                          {row[field.key] !== null &&
                          row[field.key] !== undefined
                            ? field.key.includes("fecha")
                              ? new Date(row[field.key]).toLocaleDateString()
                              : row[field.key]
                            : "N/A"}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={getTableFields().length}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <Typography variant="body1" color="textSecondary">
                          No hay datos disponibles para mostrar
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "16px 24px",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleCloseSuccessDialog}
            color="primary"
            variant="contained"
            size="large"
            sx={{ minWidth: "120px" }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDownloadDialog}
        onClose={() => setOpenDownloadDialog(false)}
      >
        <DialogTitle>Seleccione el formato a descargar:</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <RadioGroup
              value={formatoSeleccionado}
              onChange={(e) => setFormatoSeleccionado(e.target.value)}
            >
              <FormControlLabel
                value="Individual"
                control={<Radio />}
                label="Individual"
              />
              <FormControlLabel
                value="Patronal"
                control={<Radio />}
                label="Patronal"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDownloadDialog(false)} color="error">
            Cerrar
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={() => {
              if (formatoSeleccionado === "Individual") {
                descargarFormatoExcel();
              } else {
                descargarFormatoExcel2();
              }
              setOpenDownloadDialog(false); // Cerrar el dialog después de descargar
            }}
          >
            Descargar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
